import 'slick-carousel';

(function ($) {
    'use strict'
    jQuery(document).ready(function () {
        //for menu active class
        $('.button-group button').on('click', function (event) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');
            event.preventDefault();
        });

        $('.teamCarousel').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.latestPost').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.casesPost').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            prevArrow: $('.cases-prev'),
            nextArrow: $('.cases-next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.client-says-v2').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            prevArrow: $('.client-prev'),
            nextArrow: $('.client-next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    })
})(jQuery);

// (function($) {
//     $(".logos-carousel").slick({
//         dots: false,
//         infinite: false,
//         autoplay: false,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         nextArrow: '<i class="fa fa-arrow-right"></i>',
//         prevArrow: '<i class="fa fa-arrow-left"></i>'
//     });
// })(jQuery);


jQuery(document).ready(function ($) {
    "use strict"; // this function is executed in strict mode
    /* ------------------------------------------------------ */
    /*  1. SHRINK HEADER JS
    /* ------------------------------------------------------ */
    var shrinkHeader = 1;
    $(window).scroll(function () {
        var scroll = getCurrentScroll();
        if (scroll >= shrinkHeader) {
            $('.navigation').addClass('shrink');
        } else {
            $('.navigation').removeClass('shrink');
        }
    });

    function getCurrentScroll() {
        return window.pageYOffset;
    }

    var sections = $('section')
        , nav = $('nav')
        , nav_height = nav.outerHeight();

    $(window).on('scroll', function () {
        var cur_pos = $(this).scrollTop();
        sections.each(function () {
            var top = $(this).offset().top - nav_height,
                bottom = top + $(this).outerHeight();
            if (cur_pos >= top && cur_pos <= bottom) {
                nav.find('a').removeClass('active');
                sections.removeClass('active');

                $(this).addClass('active');
                nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
            }
        });
    });
    /* --------------------------- */
    /*  2. MENU SMOOTH SCROLLING JS
    /* --------------------------- */
    $(function () {
        $('a[href*="#"]:not([data-toggle="tab"])').on('click', function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

    // $('.contact-us-form').submit(function (e) {
    //     var name = $(".name-fld", this).val();
    //     var email = $(".email-fld", this).val();
    //     var phone = $(".phone-fld", this).val();
    //     var message = $("#message", this).val();
    //
    //     if (!name || !email) {
    //         alert('Please fill required fields (name, email)');
    //         return false;
    //     }
    //
    //     var dataString = 'name=' + name + '&email=' + email + '&phone=' + phone + '&message=' + message;
    //
    //     $.ajax({
    //         type: "POST",
    //         url: "sender.php",
    //         data: dataString,
    //         success: function () {
    //             alert('Thank you! We will contact with you soon.');
    //         }
    //     });
    //
    //     e.preventDefault();
    // });

});


(function ($) {
    'use strict'
    jQuery(document).ready(function () {
        //On Scroll Functionality
        $(window).scroll(() => {
            var windowTop = $(window).scrollTop();
            windowTop > 100 ? $('#menu ul').css('top', '100px') : $('#menu ul').css('top', '100px');
        });

        //Click Logo To Scroll To Top
        $('#logo').on('click', () => {
            $('html,body').animate({
                scrollTop: 0
            }, 500);
        });

        //Smooth Scrolling Using Navigation Menu
        $('a[href*="#"]').on('click', function (e) {
            $('html,body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 100
            }, 500);
            e.preventDefault();
        });

        //Toggle Menu
        $('#menu-toggle').on('click', () => {
            $('#menu-toggle').toggleClass('closeMenu');
            $('#menu ul').toggleClass('showMenu');

            $('#menu li').on('click', () => {
                $('#menu ul').removeClass('showMenu');
                $('#menu-toggle').removeClass('closeMenu');
            });
        });

        var navChildren = $("#menu li").children();
        var aArray = [];
        for (var i = 0; i < navChildren.length; i++) {
            var aChild = navChildren[i];
            var ahref = $(aChild).attr('href');
            aArray.push(ahref);
        }
    })

})(jQuery);